import { render, staticRenderFns } from "./EquatorGame.vue?vue&type=template&id=30d83304&scoped=true"
import script from "./EquatorGame.vue?vue&type=script&lang=js"
export * from "./EquatorGame.vue?vue&type=script&lang=js"
import style0 from "./EquatorGame.vue?vue&type=style&index=0&id=30d83304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d83304",
  null
  
)

export default component.exports